<script setup lang="ts">
// PROPS
interface Props {
    as?: string;
}

const { as = 'div' } = defineProps<Props>();
</script>

<template>
    <UContainer :as="as" class="flex h-full w-full flex-col gap-9 px-0 sm:px-0 lg:px-0 xl:px-0">
        <slot />
    </UContainer>
</template>
